export enum ChartTitle {
  OPEN_ORDERS = 'Open',
  PENDING_REVIEW_ORDERS = 'Pending Review',
  PENDING_APPROVAL_ORDERS = 'Pending Approval',
  ON_HOLD_ORDERS = 'On Hold',
  COMPLETED_ORDERS = 'Completed',
  PAST_DUE = 'Past Due',
  TODAY_DUE = 'Today Due',
  DUE_THIS_WEEK = 'Due This Week',
  DUE_NEXT_WEEK = 'Due Next Week',
  DUE_LATER_THIS_MONTH = 'Due Later This Month'
}

export const getStatusByChartTitle = (chartTitle: ChartTitle): string => {
  switch (chartTitle) {
    case ChartTitle.OPEN_ORDERS:
      return 'OPEN';

    case ChartTitle.PENDING_REVIEW_ORDERS:
      return 'PENDING_REVIEW';

    case ChartTitle.PENDING_APPROVAL_ORDERS:
      return 'PENDING_APPROVAL';

    case ChartTitle.ON_HOLD_ORDERS:
      return 'ON_HOLD';

    default:
      return 'COMPLETED';
  }
}